<ion-header class="ion-no-border">
  <ion-toolbar class="modal-toolbar">
    <ion-title>{{ mode() === 'block' ? 'Bloquear horário' : 'Reservar horário' }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()" aria-label="Fechar">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <!--
    Context bar EDITÁVEL. Antes era um rótulo morto vindo do @Input; agora lê
    os signals de contexto e abre o painel de troca. É isso que permite abrir
    o modal sem slot (Cliente 360 -> "Agendar") e escolher tudo aqui dentro.
  -->
  <button
    type="button"
    class="context-bar context-bar--editable"
    data-test="slot-context-bar"
    [attr.aria-expanded]="isEditingSlot()"
    (click)="toggleSlotEditor()"
  >
    @if (currentCourtImage(); as img) {
      <div class="context-thumb">
        <img [src]="img" [alt]="currentCourtName() ?? 'Quadra'" loading="lazy" />
      </div>
    } @else {
      <div class="context-thumb context-thumb--fallback">
        <ion-icon name="tennisball-outline"></ion-icon>
      </div>
    }
    <div class="context-info">
      @if (hasSlot()) {
        <div class="context-court" data-test="slot-court-name">{{ currentCourtName() ?? 'Quadra' }}</div>
        <div class="context-meta">
          <ion-icon name="calendar-outline" aria-hidden="true"></ion-icon>
          <span data-test="slot-date-label">{{ contextLabel() }}</span>
          <span class="context-dot">•</span>
          <ion-icon name="time-outline" aria-hidden="true"></ion-icon>
          <span data-test="slot-time-label">{{ currentEvent()?.start }}–{{ currentEvent()?.end }}</span>
        </div>
      } @else {
        <div class="context-court">Escolher horário</div>
        <div class="context-meta">
          <span>Selecione o dia, a quadra e o horário</span>
        </div>
      }
    </div>
    <ion-icon
      class="context-chevron"
      [name]="isEditingSlot() ? 'chevron-up' : 'chevron-forward'"
      aria-hidden="true"
    ></ion-icon>
  </button>

  @if (isEditingSlot()) {
    <div class="slot-editor" data-test="slot-editor">
      <!-- Dia (com o dia da semana visível) — mesmo organism do slot-picker. -->
      <lib-week-slides
        [dateSelected]="currentDate()"
        (newDateSelectedEvent)="onDateChange($event)" />

      @if (loadingDay()) {
        <div class="slot-editor__loading" role="status">
          <ion-spinner name="crescent"></ion-spinner>
          <span>Carregando horários…</span>
        </div>
      } @else {
        <!-- Quadra: chips em vez de ion-select. Mesma gramática da grade de
             horários logo abaixo, um toque em vez de dois, e no console
             (desktop 1280px) a lista inteira cabe na linha. -->
        <div class="slot-editor__field">
          <label class="field-label">Quadra</label>
          @if (dayCourts().length === 0) {
            <p class="slot-editor__empty" data-test="slot-no-courts">
              <ion-icon name="information-circle-outline" aria-hidden="true"></ion-icon>
              Nenhuma quadra com agenda neste dia.
            </p>
          } @else {
<!-- Card de quadra no mesmo padrão do <athlete-court-slides>: foto, selo de
                 selecionado sobre a mídia e nome ABAIXO. Como chip de texto o nome
                 estourava a linha ("INTERMEDIÁRIO/AVANÇADO"); embaixo da foto ele
                 quebra naturalmente. -->
            <div class="court-picker" data-test="slot-courts">
              @for (court of dayCourts(); track court.courtId) {
                <button
                  type="button"
                  class="court-picker__card"
                  [class.court-picker__card--active]="court.courtId === currentCourtId()"
                  [attr.aria-pressed]="court.courtId === currentCourtId()"
                  [attr.data-test]="'slot-court-' + court.courtId"
                  (click)="onCourtChange(court.courtId)"
                >
                  <span class="court-picker__media">
                    @if (court.image) {
                      <img [src]="court.image" [alt]="court.courtName" loading="lazy" />
                    } @else {
                      <ion-icon name="tennisball-outline" aria-hidden="true"></ion-icon>
                    }
                    @if (court.courtId === currentCourtId()) {
                      <span class="court-picker__check">
                        <ion-icon name="checkmark-circle" aria-hidden="true"></ion-icon>
                      </span>
                    }
                  </span>
                  <span class="court-picker__name">{{ court.courtName }}</span>
                  <span class="court-picker__count">
                    @if (bookableCountFor(court); as free) {
                      {{ free }} {{ free === 1 ? 'livre' : 'livres' }}
                    } @else {
                      Sem vaga
                    }
                  </span>
                </button>
              }
            </div>
          }
        </div>

        <!-- Horário -->
        @if (currentCourtId() !== null && currentCourtId() !== undefined) {
          <div class="slot-editor__field">
            <label class="field-label">Horário</label>
            @if (slotOptions().length === 0) {
              <p class="slot-editor__empty" data-test="slot-empty">
                <ion-icon name="information-circle-outline" aria-hidden="true"></ion-icon>
                Esta quadra não tem horários cadastrados neste dia.
              </p>
            } @else {
              @if (freeSlotCount() === 0) {
                <p class="slot-editor__empty" data-test="slot-none-free">
                  <ion-icon name="information-circle-outline" aria-hidden="true"></ion-icon>
                  Nenhum horário livre nesta quadra neste dia.
                </p>
              }
              <!-- Indisponível aparece RISCADO e desabilitado, não some: o
                   operador precisa ver que o horário existe e por que não dá. -->
              <div class="slot-editor__grid" data-test="slot-options">
                @for (slot of slotOptions(); track slot.idProvideCourt) {
                  <button
                    type="button"
                    class="slot-editor__slot"
                    [class.slot-editor__slot--active]="slot.idProvideCourt === currentEvent()?.idProvideCourt"
                    [class.slot-editor__slot--taken]="!canPick(slot)"
                    [disabled]="!canPick(slot)"
                    [attr.data-test]="(canPick(slot) ? 'slot-option-' : 'slot-taken-') + slot.idProvideCourt"
                    [attr.title]="pickBlockedReason(slot)"
                    (click)="onSlotChange(slot)"
                  >
                    <span class="slot-editor__slot-time">{{ slot.start }}–{{ slot.end }}</span>
                    @if (pickBlockedReason(slot); as reason) {
                      <span class="slot-editor__slot-reason">{{ reason }}</span>
                    } @else if (slotVacancy(slot); as vacancy) {
                      <!-- Compartilhado com vaga: quantas sobraram. Sem isso o
                           operador não distingue "livre inteiro" de "resta 1". -->
                      <span class="slot-editor__slot-reason">{{ vacancy }}</span>
                    }
                  </button>
                }
              </div>
            }
          </div>
        }
      }
    </div>
  }
</ion-header>

<ion-content
  class="modal-content"
  [class.modal-content--block]="mode() === 'block'"
>
  <!--
    Mode switch (Reservar vs Bloquear). Pill segmentado horizontal compacto —
    ocupa uma linha só, libera espaço vertical no topo do modal. Tooltip via
    `aria-label` mantém contexto ("para um cliente" / "almoço, manutenção").
  -->
  <div class="mode-switch" role="radiogroup" aria-label="Tipo de evento">
    <button
      type="button"
      class="mode-switch__option"
      [class.mode-switch__option--active]="mode() === 'rent'"
      role="radio"
      [attr.aria-checked]="mode() === 'rent'"
      aria-label="Reserva para um cliente"
      title="Reserva para um cliente"
      (click)="setMode('rent')"
    >
      <ion-icon name="people-outline" aria-hidden="true"></ion-icon>
      <span>Reserva</span>
    </button>
    <button
      type="button"
      class="mode-switch__option mode-switch__option--block"
      [class.mode-switch__option--active]="mode() === 'block'"
      role="radio"
      [attr.aria-checked]="mode() === 'block'"
      aria-label="Bloquear horário (almoço, pausa, manutenção)"
      title="Bloquear horário (almoço, pausa, manutenção)"
      (click)="setMode('block')"
    >
      <ion-icon name="lock-closed-outline" aria-hidden="true"></ion-icon>
      <span>Bloquear</span>
    </button>
  </div>

  @if (error(); as err) {
    <div class="error-box">
      <ion-icon name="alert-circle-outline"></ion-icon>
      <span>{{ err.message ?? 'Erro ao carregar dados.' }}</span>
    </div>
  }

  @if (mode() === 'block') {
    @if (!hasSlot()) {
      <!-- Sem horário escolhido, o resto do formulário não tem o que perguntar
           ao backend (fetchNewRentInfo depende de idProvideCourt). Em vez de
           campos mortos, apontamos de volta pra context bar. -->
      <div class="slot-required" data-test="slot-required" role="status">
        <ion-icon name="calendar-outline" aria-hidden="true"></ion-icon>
        <p>Escolha o dia, a quadra e o horário acima para continuar.</p>
      </div>
    } @else {
        <!-- =================================================================
             MODO BLOQUEIO: form enxuto. Só motivo (com chips de sugestão).
             A quadra, data e hora vêm do contexto do slot clicado.
             ================================================================= -->
        <div class="block-form">
          <div class="field">
            <label class="field-label">Motivo <span class="required">*</span></label>
            <ion-item fill="outline" class="field-item" lines="none">
              <ion-input
                placeholder="Ex: Almoço, Manutenção, Treino interno…"
                [value]="blockReason()"
                (ionInput)="blockReason.set($any($event.detail.value ?? ''))"
              ></ion-input>
            </ion-item>

            <div class="reason-chips">
              @for (suggestion of blockReasonSuggestions; track suggestion) {
                <button
                  type="button"
                  class="reason-chip"
                  [class.reason-chip--active]="blockReason() === suggestion"
                  (click)="pickBlockReason(suggestion)"
                >
                  {{ suggestion }}
                </button>
              }
            </div>

            @if (!blockReason().trim()) {
              <span class="field-hint">Toque numa sugestão ou digite o motivo.</span>
            }
          </div>

          <div class="block-info-card">
            <ion-icon name="information-circle-outline" aria-hidden="true"></ion-icon>
            <div>
              <strong>O que acontece:</strong>
              <span>Este horário ficará indisponível para reserva. O slot aparecerá como bloqueado na agenda. Você pode reverter depois em <em>Configurações &gt; Bloqueios</em>.</span>
            </div>
          </div>
        </div>
    }
  } @else {
      <!-- =================================================================
           MODO RESERVA: form padrão (atleta + esporte + valor + avançado).
           Renderiza SEMPRE (mesmo sem newRentInfo). Loading inline discreto
           enquanto os dados pré-preenchidos chegam — não trava o usuário.
           ================================================================= -->
      @if (!newRentInfo()) {
        <div class="loading-inline" aria-live="polite">
          <ion-spinner name="crescent"></ion-spinner>
          <span>Carregando dados do horário…</span>
        </div>
      }
      <form [formGroup]="eventForm" class="creator-form">
        <!-- Atleta -->
        <div class="field">
          <label class="field-label">
            Atleta <span class="required">*</span>
          </label>

          @if (!isWalkIn()) {
            <lib-add-new-player
              [athlete]="athleteFromPhoneSearch()"
              (athleteChange)="setAthleteSelected($event)"
            ></lib-add-new-player>
          }

          <!--
            Pacotes do cliente neste CE. Linha única e um clique: a versão que
            listava os pacotes aqui dentro virava um paredão (cliente com 16
            pacotes = 16 linhas truncadas no meio do formulário).
          -->
          @if (selectedAthlete()) {
            @if (loadingAthletePackages()) {
              <div class="athlete-packages athlete-packages--loading" aria-live="polite">
                <ion-spinner name="crescent"></ion-spinner>
                <span>Verificando pacotes do cliente…</span>
              </div>
            } @else if (selectedCoupon()) {
              <div class="athlete-packages athlete-packages--applied">
                <div class="athlete-packages__icon">
                  <ion-icon name="checkmark-circle" aria-hidden="true"></ion-icon>
                </div>
                <div class="athlete-packages__text">
                  <span class="athlete-packages__title">
                    Cupom #{{ selectedCoupon()?.couponId }} aplicado
                  </span>
                  <span class="athlete-packages__item">{{ selectedCoupon()?.packageName }}</span>
                </div>
                <ion-button
                  fill="clear"
                  size="small"
                  class="athlete-packages__remove"
                  aria-label="Remover cupom"
                  (click)="clearSelectedCoupon()"
                >
                  <ion-icon slot="icon-only" name="close-circle-outline"></ion-icon>
                </ion-button>
              </div>
            } @else if (usablePackages().length > 0) {
              <button
                type="button"
                class="athlete-packages athlete-packages--has"
                (click)="openPackagePicker()"
              >
                <div class="athlete-packages__icon">
                  <ion-icon name="ticket-outline" aria-hidden="true"></ion-icon>
                </div>
                <div class="athlete-packages__text">
                  <span class="athlete-packages__title">
                    {{ couponsAvailableTotal() }}
                    cupom{{ couponsAvailableTotal() === 1 ? '' : 's' }} disponível{{ couponsAvailableTotal() === 1 ? '' : 'is' }}
                  </span>
                  <span class="athlete-packages__item">
                    em {{ usablePackages().length }}
                    pacote{{ usablePackages().length === 1 ? '' : 's' }} · toque para usar
                  </span>
                </div>
                <ion-icon
                  class="athlete-packages__chevron"
                  name="chevron-forward"
                  aria-hidden="true"
                ></ion-icon>
              </button>
            }
          }

          <!--
            Card-botão "Cliente sem cadastro". Só faz sentido enquanto NÃO há
            atleta escolhido: depois de selecionar, ele virava um convite a
            desfazer a escolha no meio do formulário. Para trocar de cliente há
            o próprio card do atleta acima.
          -->
          @if (!selectedAthlete()) {
          <button
            type="button"
            class="walk-in-card"
            [class.walk-in-card--active]="isWalkIn()"
            (click)="toggleWalkIn()"
            [attr.aria-expanded]="isWalkIn()"
          >
            <div class="walk-in-card__icon">
              <ion-icon
                [name]="isWalkIn() ? 'arrow-back-circle-outline' : 'person-add'"
                aria-hidden="true"
              ></ion-icon>
            </div>
            <div class="walk-in-card__text">
              <span class="walk-in-card__title">
                {{ isWalkIn() ? 'Voltar a selecionar cadastrado' : 'Cliente sem cadastro?' }}
              </span>
              <span class="walk-in-card__subtitle">
                {{ isWalkIn() ? 'Buscar atleta já cadastrado' : 'Informe nome e telefone para reservar' }}
              </span>
            </div>
            <ion-icon
              class="walk-in-card__chevron"
              [name]="isWalkIn() ? 'chevron-up' : 'chevron-forward'"
              aria-hidden="true"
            ></ion-icon>
          </button>
          }

          @if (isWalkIn()) {
            <div class="walk-in-fields">
              <div class="walk-in-fields__row">
                <ion-item fill="outline" class="field-item" lines="none">
                  <ion-icon slot="start" name="person-outline" aria-hidden="true"></ion-icon>
                  <ion-input
                    formControlName="nameOwner"
                    placeholder="Nome do cliente"
                    autocapitalize="words"
                  ></ion-input>
                </ion-item>
                @if (eventForm.get('nameOwner')?.touched && !eventForm.get('nameOwner')?.value?.trim()) {
                  <span class="field-hint field-hint--error">Informe o nome do cliente.</span>
                }
              </div>

              <div class="walk-in-fields__row">
                <lib-phone-input formControlName="cellphone"></lib-phone-input>
                @if (isWalkInPhoneInvalid()) {
                  <span class="field-hint field-hint--error">Informe um telefone válido para o país selecionado.</span>
                } @else {
                  <span class="field-hint">Telefone obrigatório para reservas sem cadastro.</span>
                }
                <button
                  type="button"
                  class="walk-in-search-link"
                  (click)="openFindByPhone()"
                >
                  <ion-icon name="search-outline" aria-hidden="true"></ion-icon>
                  Já tem cadastro? Buscar pelo telefone
                </button>
              </div>
            </div>
          } @else {
            @if (eventForm.get('nameOwner')?.touched && !eventForm.get('idAtleta')?.value && !eventForm.get('nameOwner')?.value) {
              <span class="field-hint field-hint--error">Selecione um atleta ou cadastre manualmente.</span>
            }
          }
        </div>

        <!-- O cliente fica ACIMA e FORA do guard de horário: vindo do
             Cliente 360 ele é o dado já resolvido e o horário é a
             pergunta. Escondê-lo até haver slot obrigava o operador a
             escolher um horário só pra conferir se abriu o cliente certo. -->
        <!-- Ocupação REVERSÍVEL (atleta em checkout ou cobrança em aberto). Avisa, não
             bloqueia: o hold é camada advisory e o CE é dono da quadra. O que muda é que
             ele decide sabendo. Não vem da grade — a agenda é cacheada 5 min e o hold
             vive 10; este dado é buscado na escolha do horário. -->
        @if (slotContestedBy(); as contested) {
          <div class="contested" role="status" data-test="slot-contested">
            <ion-icon name="alert-circle-outline" aria-hidden="true"></ion-icon>
            <div>
              @if (contested.held > 0) {
                <strong>
                  {{ contested.held === 1 ? 'Um atleta está pagando este horário agora' : contested.held + ' atletas estão pagando este horário agora' }}
                </strong>
              } @else {
                <strong>Este horário tem cobrança em aberto</strong>
              }
              <span>
                @if (contested.seconds !== null) {
                  Libera em {{ countdown(contested.seconds) }} se o pagamento não sair.
                } @else if (contested.awaiting > 0) {
                  {{ contested.awaiting === 1 ? 'Uma vaga está' : contested.awaiting + ' vagas estão' }}
                  reservadas sem pagamento confirmado — voltam sozinhas se não pagarem.
                } @else {
                  A vaga volta sozinha se o pagamento não for concluído.
                }
                Reservar agora pode tirar o horário de quem está pagando.
              </span>
            </div>
          </div>
        }

        @if (isJoiningSharedRent()) {
          <!-- A reserva já existe: esporte, valor, vagas e janela são dela.
               Pedir de novo aqui daria a impressão de que o CE está criando
               algo novo — e o POST /players ignoraria tudo. -->
          <div class="join-shared" role="status">
            <ion-icon name="people-outline" aria-hidden="true"></ion-icon>
            <div>
              <strong>Entrando num horário compartilhado</strong>
              <span>
                @if (joinRemainingSpots() > 0) {
                  {{ joinRemainingSpots() }}
                  {{ joinRemainingSpots() === 1 ? 'vaga livre' : 'vagas livres' }} —
                } @else {
                  Sem vaga livre agora —
                }
                o cliente entra na reserva que já existe. Esporte e valor vêm dela.
              </span>
            </div>
          </div>
        } @else if (!hasSlot()) {
        <!-- Sem horário escolhido, o resto do formulário não tem o que perguntar
             ao backend (fetchNewRentInfo depende de idProvideCourt). Em vez de
             campos mortos, apontamos de volta pra context bar. -->
        <div class="slot-required" data-test="slot-required" role="status">
          <ion-icon name="calendar-outline" aria-hidden="true"></ion-icon>
          <p>Escolha o dia, a quadra e o horário acima para continuar.</p>
        </div>
        } @else {
          <!-- Esporte -->
          <div class="field">
            <label class="field-label">
              Esporte <span class="required">*</span>
            </label>
            <ion-item fill="outline" class="field-item" lines="none">
              <ion-select
                formControlName="sportId"
                placeholder="Selecione o esporte"
                interface="popover"
                (ionChange)="changeSport($event)"
              >
                @for (sport of sports(); track sport.id) {
                  <ion-select-option [value]="sport.id">{{ sport.name }}</ion-select-option>
                }
              </ion-select>
            </ion-item>
            @if (eventForm.get('sportId')?.touched && !eventForm.get('sportId')?.value) {
              <span class="field-hint field-hint--error">Selecione um esporte.</span>
            }
          </div>

          <!-- Vagas (apenas HORARIO_COMPARTILHADO) -->
          @if (isSharedSlot()) {
            <div class="field">
              <label class="field-label">Vagas para este cliente</label>
              @if (isSlotFull()) {
                <div class="vacancies-empty" role="alert">
                  <ion-icon name="alert-circle-outline" aria-hidden="true"></ion-icon>
                  <span>Sem vagas disponíveis neste horário.</span>
                </div>
              } @else {
                <div class="vacancies-row">
                  <lessor-quantity-stepper
                    [value]="vacanciesForThisRent()"
                    [min]="1"
                    [max]="maxVacancies()"
                    [decLabel]="'Diminuir vagas'"
                    [incLabel]="'Aumentar vagas'"
                    (valueChange)="setVacancies($event)"
                  ></lessor-quantity-stepper>
                  <span class="vacancies-context">
                    de {{ maxVacancies() }} disponíveis
                    @if (maxVacancies() !== totalVacancies()) {
                      ({{ totalVacancies() }} no total)
                    }
                  </span>
                </div>
              }
            </div>
          }

          <!-- Valor -->
          <div class="field">
            <label class="field-label">
              {{ isSharedSlot() ? 'Valor por vaga' : 'Valor' }}
            </label>
            <ion-item fill="outline" class="field-item" lines="none">
              <!--
                `maskBrlCurrencyFormat` aplicado com initialValue=undefined.
                Bindar `[maskBrlCurrencyFormat]="eventForm.get('value')?.value"`
                causa NG0100: a diretiva chama `setValue` no FormControl em dev
                mode durante a 2ª passada de change detection e o Angular detecta
                que a expressão mudou de "120" para "R$ 120,00" no mesmo ciclo,
                abortando o render (footer/botão somem).
                Passamos `$any(undefined)` para o ngOnInit da diretiva ignorar a
                inicialização (ela checa `if (initialValue !== undefined)`); a
                formatação acontece via `(input)` listener quando o usuário digita.
              -->
              <!--
                Sem `slot="start">R$`: a directiva `maskBrlCurrencyFormat` já
                formata o valor com prefixo "R$ " (Intl.NumberFormat BRL). Ter
                os dois faz o campo mostrar "R$ R$ 80,00".
              -->
              <ion-input
                formControlName="value"
                placeholder="0,00"
                [maskBrlCurrencyFormat]="$any(undefined)"
              ></ion-input>
            </ion-item>
            <span class="field-hint">Pré-preenchido conforme cadastro da quadra.</span>
            @if (isSharedSlot() && vacanciesForThisRent() > 1) {
              <span class="field-hint field-hint--strong">
                Total da quadra: R$ {{ totalCourtValue() | number:'1.2-2' }}
                ({{ vacanciesForThisRent() }} × valor por vaga)
              </span>
            }
          </div>

          <!-- Equipamentos -->
          <lessor-equipment-picker
            [date]="currentDate()"
            [provideCourtId]="currentEvent()?.idProvideCourt ?? null"
            [sportId]="eventForm.get('sportId')?.value ?? null"
            [maxPerEquipment]="isSharedSlot() ? vacanciesForThisRent() : 1"
            (selectionChange)="onEquipmentsChange($event)"
            (totalChange)="onEquipmentsTotalChange($event)"
          ></lessor-equipment-picker>

          <!-- Avançado -->
          <button
            type="button"
            class="advanced-toggle"
            (click)="toggleAdvanced()"
            [attr.aria-expanded]="isAdvancedOpen()"
          >
            <ion-icon
              name="chevron-forward-outline"
              [class.rotated]="isAdvancedOpen()"
            ></ion-icon>
            <span>Configurações avançadas</span>
          </button>

          @if (isAdvancedOpen()) {
            <div class="advanced-section">
              <div class="field">
                <label class="field-label">Janela de agendamento</label>
                <ion-item lines="none" class="field-item field-item--checkbox">
                  <ion-checkbox
                    labelPlacement="end"
                    justify="start"
                    [checked]="isNoWindowBooking()"
                    (ionChange)="isNoWindowBooking.set($any($event.detail.checked))"
                  >
                    Sem janela de agendamento
                  </ion-checkbox>
                </ion-item>
                @if (!isNoWindowBooking()) {
                  <lib-booking-window
                    [opensAt]="eventForm.get('opensAt')?.value ?? 0"
                    [closesAt]="eventForm.get('closesAt')?.value ?? 0"
                    (bookingWindow)="setBookingWindow($event)"
                  ></lib-booking-window>
                }
              </div>
            </div>
          }
        }
      </form>
  }

</ion-content>

<!--
  Footer real do Ionic — pinado no rodapé do modal em qualquer tamanho de
  tela. Tentativa anterior usava `position: sticky` dentro do <ion-content>;
  funcionava no mobile (fullscreen) mas, no desktop/tablet (modal centrado
  como card), o conteúdo nem sempre overflow-a e o sticky caía no fluxo
  normal — buracos abaixo do formulário e botões "sumindo" no card grande.
  Com :host em flex-column, ion-content cresce e ion-footer fica colado.
-->
<ion-footer class="modal-footer" [class.modal-footer--block]="mode() === 'block'">
  <div class="modal-actions">
    @if (mode() === 'block') {
      <div class="modal-actions__summary">
        Bloqueando {{ currentEvent()?.start }}–{{ currentEvent()?.end }} em {{ currentCourtName() ?? 'esta quadra' }}
      </div>
    }
    <div class="modal-actions__buttons">
      <ion-button fill="clear" (click)="dismiss()" [disabled]="isLoading()">
        Cancelar
      </ion-button>
      @if (mode() === 'block') {
        <ion-button
          color="medium"
          (click)="confirm()"
          [disabled]="isLoading() || !hasSlot() || !blockReason().trim()"
        >
          @if (isLoading()) {
            <ion-spinner slot="start" name="crescent"></ion-spinner>
            <span>Salvando…</span>
          } @else {
            <ion-icon slot="start" name="lock-closed-outline"></ion-icon>
            <span>Bloquear horário</span>
          }
        </ion-button>
      } @else {
        <ion-button
          color="primary"
          class="confirm-btn"
          (click)="slotContestedBy() ? confirmOverridingContested() : confirm()"
          data-test="confirm-rent"
          [disabled]="isLoading() || !hasSlot() || isSlotFull()"
        >
          @if (isLoading()) {
            <ion-spinner slot="start" name="crescent"></ion-spinner>
            <span>Salvando…</span>
          } @else {
            <ion-icon slot="start" name="checkmark-circle-outline"></ion-icon>
            <span class="confirm-btn__label">
              <!-- Entrando num compartilhado o CE não define preço: o valor é o
                   da reserva que já existe. Mostrar um total aqui prometeria
                   uma cobrança que este fluxo não cria. -->
              <!-- O rótulo assume a responsabilidade: sobre horário disputado, o
                   operador precisa ler que está passando por cima de alguém. -->
              <span class="confirm-btn__title">
                @if (slotContestedBy()) {
                  Reservar assim mesmo
                } @else {
                  {{ isJoiningSharedRent() ? 'Adicionar ao horário' : 'Confirmar reserva' }}
                }
              </span>
              @if (!isJoiningSharedRent() && totalReservation() > 0) {
                <span class="confirm-btn__total">
                  R$ {{ totalReservation() | number:'1.2-2' }}
                </span>
              }
            </span>
          }
        </ion-button>
      }
    </div>
  </div>
</ion-footer>
